import * as React from 'react';
import clsx from 'clsx';
import { withStyles, WithStyles } from '@material-ui/core/styles';
import TranslateNew from '@translate/TranslateNew';
import { subscriptionStyle } from "./subscription.style";
import { ISubscription, SubscriptionPlatform } from '@app-types/websocket/subscription.types';
import { IFamilyMember } from '@app-types/websocket/family.types';

const tn :TranslateNew = TranslateNew.getInstance();

interface IProps extends WithStyles<typeof subscriptionStyle> {
  subscription:ISubscription;
  accountId:number;
  family:IFamilyMember[];
}


class Subscription extends React.Component<IProps, {}> {


  public render() {
    const style = this.props.classes;

    let daysLeft = "unknown";
    let expired = false;
    if (this.props.subscription.expirationTime) {
      if (this.props.subscription.expirationTime - Date.now() <= 0) {
        expired = true;
        daysLeft = tn.lang.subTimeOut;
      } else {
        daysLeft = tn.lang.momentFromNow(this.props.subscription.expirationTime);
      }
    }

    let manage = tn.lang.subManage;

    let name = 'unknown';
    if (this.props.subscription === undefined) {
      name = tn.lang.unknown;
    } else if (this.props.subscription.platform === SubscriptionPlatform.CAMPAIGN && this.props.subscription.name !== undefined) {
      name = this.props.subscription.name;
    } else if (this.props.subscription.accountId !== this.props.accountId) {
      name = tn.lang.subByUser(tn.familyMemberName(this.props.subscription.accountId, this.props.family) );
    } else if (this.props.subscription.platform === SubscriptionPlatform.APPLE) {
      manage = tn.lang.subManageApp;
      name = tn.lang.subApple;
    } else if (this.props.subscription.platform === SubscriptionPlatform.APPLE_TEST) {
      manage = tn.lang.subManageApp;
      name = tn.lang.subAppleTest;
    } else if (this.props.subscription.platform === SubscriptionPlatform.GOOGLE) {
      manage = tn.lang.subManageApp;
      name = tn.lang.subGoogle;
    } else if (this.props.subscription.platform === SubscriptionPlatform.GOOGLE_TEST) {
      manage = tn.lang.subManageApp;
      name = tn.lang.subGoogleTest;
    } else if (this.props.subscription.platform === SubscriptionPlatform.WEB) {
      name = tn.lang.subWeb;
    } else if (this.props.subscription.platform === SubscriptionPlatform.WEB_TEST) {
      name = tn.lang.subWebTest;
    }

    return (
      <div className={clsx(style.sub, expired ? style.subExpired : style.subActive)}>
        <h3 className={style.subAccess}>
          <span className={expired ? style.expiredDot : style.liveDot} />
          {tn.lang.subFullAccess}
        </h3>
        <h4 className={style.subName}>{name}</h4>
        <hr className={style.subDivider} />
        <div>
          <h3 className={style.subLabel}>{tn.lang.subTimeLeft}</h3>
          <h2 className={style.subTimeLeft}>{daysLeft}</h2>
        </div>
        <h3 className={style.subManage}>{manage}</h3>
      </div>
    );
  }
}


export default withStyles(subscriptionStyle)(Subscription);


// WEBPACK FOOTER //
// ./src/components/subscription/Sub.tsx